module.exports = __webpack_public_path__ + "b5a06993f053f78ae15fdd36750ddb7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/step-2.png
// module id = 171
// module chunks = 0 1